import { API } from '../config/config';

const ArticuloService = {
  getAll: () => getArticulos(),
  getAllPaginated: (params = {}) => getArticulosPaginated(params),
  getAllArticlesInStore: (storeId) => getArticulosInStore(storeId),
  getAllArticlesInStoreTo: (storeId, to, onlyWithStock, page, limit, withOffers = true) => getArticulosInStoreTo(storeId, to, onlyWithStock, page, limit, withOffers),
  save: (data) => saveArticulo(data),
  saveArticleInStore: (storeId, data) => saveArticleInStore(storeId, data),
  updateArticleInStore: (data) => updateArticleInStore(data),
  update: (storeId, articleId, data) => storeId ? updateArticuloInStoreDetailed(storeId, articleId, data) : updateArticulo(articleId, data),
  updateVariants: (storeId, articleId, typeDetail) => updateVariants(storeId, articleId, typeDetail),
  updateImages: (storeId, articleId, images) => updateImages(storeId, articleId, images),
  recategorize: (storeId, articleId, categoryId) => recategorizeArticle(storeId, articleId, categoryId),
  search: (query) => searchArticulos(query),
  searchArticlesInStore: (storeId, query, articlesTo, onlyWithStock, page, withOffers = true) => searchArticulosInStore(storeId, query, articlesTo, onlyWithStock, page, withOffers),
  searchArticlesInStore2: (storeId, params) => searchArticulosInStore2(storeId, params),
};

const normalizeArticleList = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (!payload || typeof payload !== 'object') return [];
  if (Array.isArray(payload.items)) return payload.items;
  if (Array.isArray(payload.docs)) return payload.docs;
  if (Array.isArray(payload.results)) return payload.results;
  if (Array.isArray(payload.articles)) return payload.articles;
  if (Array.isArray(payload.data)) return payload.data;
  return [];
};

const saveArticulo = async (data) => {
  try {
    var response = await API.post('/articles', data)
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err)
  }
}

const saveArticleInStore = async (storeId, data) => {
  try {
    var response = await API.post(`/stores/${storeId}/articles`, data)
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err)
  }
}

const getArticulos = async () => {
  try {
    var response = await API.get('/articles')
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err)
  }
}

const getArticulosPaginated = async ({ page = 1, limit = 20, name = '' } = {}) => {
  try {
    const response = await API.get('/articles', {
      params: {
        page,
        limit,
        ...(name ? { name } : {})
      }
    });
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err);
  }
}

const getArticulosInStore = async (storeId) => {
  try {
    var response = await API.get(`/stores/${storeId}/articles`)
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err)
  }
}

const getArticulosInStoreTo = async (storeId, to, onlyWithStock = false, page = 1, limit = 20, withOffers = true) => {
  try {
    const response = await API.get(`/stores/${storeId}/articles`, {
      params: {
        page,
        limit,
        to,
        onlyStock: onlyWithStock,
        offers: withOffers,
      }
    });
    return normalizeArticleList(response.data);
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err)
  }
}

const searchArticulos = async (query) => {
  try {
    var response = await API.get('/articles?name='+ query)
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err)
  }
}

const searchArticulosInStore = async (storeId, query, articlesTo, onlyStock = false, page = 1, withOffers = true) => {
  try {
    const response = await API.get(`/stores/${storeId}/articles`, {
      params: {
        page,
        name: query,
        to: articlesTo,
        onlyStock,
        offers: withOffers,
      }
    });
    return normalizeArticleList(response.data);
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err)
  }
}

const searchArticulosInStore2 = async (storeId, params) => {
  try {
    var response = await API.get(`/stores/${storeId}/articles?${params.toString()}`)
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err)
  }
}

const updateArticleInStore = async (data) => {
  try {
    var response = await API.post('/stores/updateStock', data)
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err)
  }
}

// Actualiza un artículo global (endpoint sin store)
const updateArticulo = async (articleId, data) => {
  try {
    const response = await API.put(`/articles/${articleId}`, data);
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err);
  }
};

// Actualiza artículo específico dentro de una tienda
const updateArticuloInStoreDetailed = async (storeId, articleId, data) => {
  try {
    const payload = {
      ...data,
      article: {
        name: data?.article?.name || '',
        description: data?.article?.description || '',
        images: Array.isArray(data?.article?.images) ? data.article.images : [],
        web: data?.article?.web || false
      },
      prices: {
        list_price: Number(data?.prices?.list_price || 0),
        sale_price: Number(data?.prices?.sale_price || 0)
      },
      customer:
        typeof data?.customer === 'string'
          ? data.customer
          : (data?.customer?._id || data?.customer_id || '')
    };

    const response = await API.put(`/stores/${storeId}/articles/${articleId}`, payload);
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err);
  }
};

// Actualiza solo las imágenes de un artículo en una tienda
const updateImages = async (storeId, articleId, images) => {
  try {
    const response = await API.put(`/stores/${storeId}/articles/${articleId}`, { article: { images } });
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err);
  }
};

// Actualiza las variantes (type_detail) de un artículo en una tienda
const updateVariants = async (storeId, articleId, typeDetail) => {
  try {
    const response = await API.put(`/stores/${storeId}/articles/${articleId}/variants`, {
      type_detail: typeDetail
    });
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err);
  }
};

const recategorizeArticle = async (storeId, articleId, categoryId) => {
  try {
    const response = await API.patch(`/stores/${storeId}/articles/${articleId}/category`, { category_id: categoryId });
    return response.data;
  } catch (err) {
    console.error('Error recategorizing article:', err);
    throw err;
  }
};

export default ArticuloService;
